<template>
  <section class="flow">
    <h2 class="flow__participation">{{ DataFlowParticipation.title[lang] }}</h2>
    <ol class="flow__list">
      <li class="flow__list--item">
        <h3 class="step-title">STEP 1</h3>
        <figure class="flow-figure">
          <img src="../../../assets/images/flow/step_01.svg" alt="" />
        </figure>
        <h4
          class="flow-title"
          v-html="DataFlowParticipation.flows[0].download[lang]"
        ></h4>
      </li>
      <li class="flow__list--item">
        <h3 class="step-title">STEP 2</h3>
        <figure class="flow-figure">
          <img src="../../../assets/images/flow/step_02.svg" alt="" />
        </figure>
        <h4
          class="flow-title"
          v-html="DataFlowParticipation.flows[1].entry[lang]"
        ></h4>
      </li>
      <li class="flow__list--item">
        <div class="border-important"></div>
        <p class="important">{{ DataFlowParticipation.important[lang] }}</p>
        <h3 class="step-title">STEP 3</h3>
        <figure class="flow-figure">
          <img src="../../../assets/images/flow/step_03.svg" alt="" />
        </figure>
        <router-link
          class="app-sync t-underline"
          :to="{ path: `/${langPath}confirmation` }"
        >
          <img
            class="img-triangle"
            src="../../../assets/images/triangle-right-purple.svg"
            alt=""
          />
          {{ DataFlowParticipation.appSync[lang] }}
        </router-link>
        <h4 class="flow-title">
          {{ DataFlowParticipation.flows[2].coop[lang] }}
        </h4>
      </li>
      <li class="flow__list--item">
        <h3 class="step-title">STEP 4</h3>
        <figure class="flow-figure">
          <img src="../../../assets/images/flow/step_05.svg" alt="" />
        </figure>
        <h4 class="flow-title">
          {{ DataFlowParticipation.flows[3].save[lang] }}
        </h4>
      </li>
      <li class="flow__list--item">
        <h3 class="step-title">STEP 5</h3>
        <figure class="flow-figure">
          <img src="../../../assets/images/flow/step_06.svg" alt="" />
        </figure>
        <h4 class="flow-title">
          {{ DataFlowParticipation.flows[4].ranking[lang] }}
        </h4>
      </li>
    </ol>
  </section>
</template>

<script>
import DataFlowParticipation from "../../../assets/constants/top/flow-participation";
export default {
  data() {
    return {
      DataFlowParticipation: DataFlowParticipation,
    };
  },
  props: {
    lang: {
      type: String,
    },
    langPath: {
      type: String,
    },
  },
  name: "FlowParticipation",
};
</script>

<style scoped>
h2 {
  font-size: 32px;
  line-height: 1.25;
}
h3 {
  font-size: 30px;
  line-height: 1;
}
h4 {
  font-size: 24px;
  line-height: 1.17;
}
.flow {
  text-align: center;
  &__participation {
    margin: 50px 36px 0 36px;
  }
  &__list {
    display: flex;
    flex-direction: column;
    align-items: center;
    &--item {
      margin: 25px 0 0 0;
      position: relative;
      &:first-of-type {
        margin: 30px 0 0 0;
      }

      .step-title {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 124px;
        height: 40px;
        border: solid 1px var(--defaultBlackColor);
      }

      &:not(:first-of-type) {
        .step-title {
          margin: 55px 0 0 0;
          position: relative;

          &::before {
            content: "";
            display: inline-block;
            width: 60px;
            height: 30px;
            background: url("../../../assets/images/triangle-bottom.png")
              no-repeat center / 60px 30px;
            position: absolute;
            top: -50px;
            left: 50%;
            transform: translate(-50%);
          }
        }
      }

      /*「重要対応」*/
      &:nth-of-type(3) {
        .step-title {
          margin: 70px 0 0 0;
          &::before {
            top: -70px;
          }
        }
      }

      .border-important {
        width: 300px;
        height: 316px;
        border: solid 1px var(--yellowFoundationColor);
        position: absolute;
        top: 52px;
        left: 50%;
        transform: translateX(-50%);
        z-index: -1;
      }

      .important {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 126px;
        height: 24px;
        font-size: 14px;
        font-weight: bold;
        color: var(--defaultWhiteColor);
        background-color: var(--yellowFoundationColor);
        position: absolute;
        top: 40px;
        left: 50%;
        transform: translateX(-50%);
      }

      .flow-figure {
        margin: 20px 0 0 0;
        img {
          width: 200px;
          height: auto;
        }
      }

      .app-sync {
        margin: 12px 0 0 0;
        display: inline-flex;
        justify-content: center;
        font-weight: bold;
        .img-triangle {
          margin: 0 4px 0 0;
        }
      }

      .flow-title {
        margin: 20px 36px 0 36px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sp/top/FlowParticipation.vue